export const deliveryErrors = [
    { Id: 'address_not_found', Name: 'Адрес не найден' },
    { Id: 'address_too_far', Name: 'Адрес слишком далеко' },
    { Id: 'apply_change_error', Name: 'Ошибка применения изменений' },
    { Id: 'bad_request', Name: 'Ошибка запроса' },
    { Id: 'cancel_error', Name: 'Ошибка отмены' },
    { Id: 'cargo_payments_update_error', Name: 'Ошибка обновления грузовых тарифов' },
    { Id: 'change_destination_error', Name: 'Ошибка изменения конечной точки' },
    { Id: 'claim_is_outdated', Name: 'Заявка устарела' },
    { Id: 'claim_not_ready', Name: 'Заявка не готова' },
    { Id: 'claim_point_not_ready', Name: 'Не заданы точки заявки' },
    { Id: 'confirmation_code_required', Name: 'Требуется код подтверждения' },
    { Id: 'cost_mismatch', Name: 'Несоответствие стоимости' },
    { Id: 'country_phone_code_not_supported', Name: 'Код страны номера телефона не поддерживается' },
    { Id: 'currency_mismatch', Name: 'Несоответствие валюты' },
    { Id: 'custom_context_in_bad_format', Name: 'Ошибка формата контекста' },
    { Id: 'db_error', Name: 'Внутренняя ошибка бд' },
    { Id: 'delay_too_long', Name: 'Слишком долгое ожидание' },
    { Id: 'double_request', Name: 'Повторный запрос' },
    { Id: 'due_in_past', Name: 'Время доставки в прошлом' },
    { Id: 'duplicate_id', Name: 'Дублткат id' },
    { Id: 'duplicate_source_point', Name: 'Дублткат начальной точки' },
    { Id: 'esignature_error', Name: 'Ошибка подписи' },
    { Id: 'esignature_too_many_requests', Name: 'Слишком много запросов подписи' },
    { Id: 'external_order_id_not_allowed', Name: 'Внешний id заказа не поддерживается' },
    { Id: 'free_cancel_is_unavailable', Name: 'Бесплатная доставка недоступна' },
    { Id: 'inappropriate_point', Name: 'Несоответствующая точка' },
    { Id: 'inappropriate_status', Name: 'Несоответствующий статус' },
    { Id: 'invalid_cursor', Name: 'Некорректный указатель' },
    { Id: 'invalid_destination_point', Name: 'Некорректная точка назначения' },
    { Id: 'invalid_destination_point_phone', Name: 'Некорректный телефон (точка назначения)' },
    { Id: 'invalid_emergency_contact_phone', Name: 'Некорректный экстренный телефон' },
    { Id: 'invalid_fiscalization_status', Name: 'Некорректный статус фискализации' },
    { Id: 'invalid_item_destination_point', Name: 'Некорректный товар в точке назначения' },
    { Id: 'invalid_item_source_point', Name: 'Некорректный товар в начальной точке' },
    { Id: 'invalid_payment_mode', Name: 'Некорректный метод оплаты' },
    { Id: 'invalid_payment_subject', Name: 'Некорректный субъект оплаты' },
    { Id: 'invalid_phone_incorrect_symbol', Name: 'Некорректный телефон(передан некорректный символ)' },
    { Id: 'invalid_phone_must_start_plus_symbol', Name: 'Некорректный телефон(телефон должен начинаться с +)' },
    { Id: 'invalid_phone_size_incorrect', Name: 'Некорректный телефон(некорректная длинна номера)' },
    { Id: 'invalid_point_phone', Name: 'Некорректный телефон в точке' },
    { Id: 'invalid_post_payment', Name: 'Ошибка постоплаты' },
    { Id: 'invalid_return_point_phone', Name: 'Некорректная точка возврата' },
    { Id: 'invalid_source_point', Name: 'Некорректная начальная точка' },
    { Id: 'invalid_source_point_phone', Name: 'Некорректный телефон (начальная точка)' },
    { Id: 'invalid_time_intervals', Name: 'Некорректный временной интервал' },
    { Id: 'item_destination_point_not_found', Name: 'Не найден товар, указанный в точке назначения' },
    { Id: 'item_has_no_fiscalization', Name: 'Не указана фискализация для товара' },
    { Id: 'item_source_point_not_found', Name: 'Не найден товар, указанный в начальной точке' },
    { Id: 'items_without_parameters_forbidden', Name: 'Не указаны параметры товара' },
    { Id: 'no_input_point', Name: 'Нет точки входа' },
    { Id: 'no_performer_info', Name: 'Нет информации об исполнителе' },
    { Id: 'no_required_email_for_point', Name: 'Не указан email в точке' },
    { Id: 'not_allowed', Name: 'Не поддерживается' },
    { Id: 'not_found', Name: 'Не найдено' },
    { Id: 'offer_expired', Name: 'Срок действия предложения истек' },
    { Id: 'old_lookup_version', Name: 'Указана старая версия при поиске' },
    { Id: 'old_version', Name: 'Старая версия' },
    { Id: 'order_creation_conflict', Name: 'Проблема при создании заявки' },
    { Id: 'parse_error', Name: 'Ошибка разбора данных' },
    { Id: 'payment_and_skip_sms_conflict', Name: 'Конфликт оплаты и пропуска смс' },
    { Id: 'payment_on_delivery_disabled', Name: 'Отключена оплата при доставке' },
    { Id: 'payment_on_delivery_invalid_request', Name: 'Ошибка при запросе оплаты доставки' },
    { Id: 'payment_on_delivery_invalid_token', Name: 'Неверный токен ' },
    { Id: 'payment_required', Name: 'Запрос оплаты' },
    { Id: 'payment_sms_send_failed', Name: 'Ошибка отправки смс оплаты' },
    { Id: 'payment_terminal_error', Name: 'Ошибка терминала оплаты' },
    { Id: 'pdf_failure', Name: 'Сбой PDF' },
    { Id: 'point_not_found', Name: 'Точка не найдена' },
    { Id: 'report_generating_disabled', Name: 'Отключено создание отчета' },
    { Id: 'report_intervals_validation_error', Name: 'Ошибка отчета проверки интервалов' },
    { Id: 'report_not_found', Name: 'Отчет не найден' },
    { Id: 'send_email_error', Name: 'Ошибка отправки email' },
    { Id: 'solver_failed', Name: 'Проблема решения' },
    { Id: 'source_point_missing', Name: 'Отсутствует начальная точка' },
    { Id: 'state_mismatch', Name: 'Несовпадение статусов' },
    { Id: 'state_transition_forbidden', Name: 'Переход состояния запрещен' },
    { Id: 'tariff_error', Name: 'Переход состояния запрещен' },
    { Id: 'task_not_found', Name: 'Задача не найдена' },
    { Id: 'too_few_points', Name: 'Слишком много точек' },
    { Id: 'too_much_claim_edits', Name: 'Слишком много правок' },
    { Id: 'unknown_performer_position', Name: 'Неизвестная позиция исполнителя' },
    { Id: 'unknown_zone', Name: 'Неизвестная зона' },
    { Id: 'unsupported_points_count', Name: 'Количество неподдерживаемых точек' },
    { Id: 'use_waybills_admin_page', Name: 'Используйте страницу администратора накладных' },
    { Id: 'validation_error', Name: 'Ошибка проверки' },
    { Id: 'wrong_corp_client_id', Name: 'Неверный id корп клиента' },
    { Id: 'wrong_pickup_code_format', Name: 'Неправильный формат кода получения' },
    { Id: 'wrong_pickup_code_usage', Name: 'неправильное использование кода получения' },
    { Id: 'wrong_taxi_order_id', Name: 'Неверный id такси заказа' },
    { Id: 'terminal_status', Name: 'Статус терминала' },
    { Id: '-100', Name: 'Внутренняя ошибка' },
    { Id: '-1', Name: 'Отмена доставки невозможна' },
    { Id: '-2', Name: 'Заказ не найден' },
    { Id: '-3', Name: 'Для заказа не была создана заявка на доставку' },
    { Id: '-4', Name: 'Ошибка обновления статуса' }
];


// WEBPACK FOOTER //
// ./src/constants/deliveryErrors.js